// props are set manually validation is not needed
import React, { useState, useEffect } from 'react';
import { Translation } from 'react-i18next';
import i18n from 'i18next';
import CustomTemplate from '../customtemplate/customtemplate.jsx';
import getTemplate from '../../utils/gettemplate';
import './searchform.scss';
import '../ctablock/ctablock.scss';

const SearchForm = (props) => {
  // React requires onChange on input fields otherwise it considers the read only
  // can not map userLocationString directly to prop as this triggers page reload
  // onChange does not appear to work with non-state variables

  // Component State
  const [userLocationString, setUserLocationString] = useState(props.userLocation.userLocationString || '');

  // Element variable
  let SearchButton;
  const Template = getTemplate(props, 'search-button');

  // Element content variable
  let inputString = 'Enter Zip code or city, state';
  const accessibilityString = i18n.t('toSortListBelow');
  const inputProps = {};

  // event management variables
  const handleChange = (event) => {
    setUserLocationString(event.target.value);
  };

  const handleSearchformSubmit = (event) => {
    // Only one searchInputType as of 12/2020
    if (props.searchInputType === 'uszip5') {
      // Will only accept 5 digit address
      if ((userLocationString).length === 5) {
        props.handleSearchSubmit(event);
      } else {
        // If user tries to submit invalid number submission is blocked
        event.preventDefault();
        // Input clears to display placeholder message
        setUserLocationString('');
      }
    } else if ((userLocationString).length > 0) {
      // Prevents 400 error caused by clicking submit on empty input field
      props.handleSearchSubmit(event);
    } else {
      // Stops page from jumping to top when empty input field is submitted
      event.preventDefault();
    }
  };

  useEffect(() => {
    if (props.resetInputIdLocation) {
      props.setUserLocation({
        userLocationString: '', 
        userLatitude: null, 
        userLongitude: null,
      });
    }
  });

  useEffect(() => {
    setUserLocationString(props.userLocation.userLocationString);
  }, [props.userLocation.userLocationString]);

  if (Template) {
    SearchButton = <CustomTemplate template={Template} />;
  }

  if (props.searchInputType === 'uszip5') {
    inputProps.pattern = '[0-9]*';
    inputString = 'Enter five digit Zip code';
  }

  const form = (
    <Translation>{(t) => {
      return (
        <form onSubmit={handleSearchformSubmit} autoComplete="off" role="search" action=".">
          <input
            aria-controls="locations-list, Google-Map-Container"
            aria-label={props.searchInputPlaceholderText || t(accessibilityString)}
            id="id_location"
            name="location"
            placeholder={props.searchInputPlaceholderText || t(inputString)}
            {...inputProps}
            type="search"
            value={userLocationString}
            onChange={handleChange} />
            {props.filtersLayout !== 'inline-buttons-below' ? SearchButton || (<button type="submit">{t('Go')}</button>) : ''}
        </form>
      );
    }}</Translation>
  );
  
  return (
    form 
  );
};

export default SearchForm;
